import React, { ReactNode } from "react";
import { State } from "react-burger-menu";
import { useRenderOn } from "src/hooks";

import { Sidebar } from "../../../../../components";

import AppContentMenu from "./components/AppMenuContent";

export interface IProps {
  children?: ReactNode;
  isOpen: boolean;
  toggleMenu: (state: State) => void;
}

const AppMenu = ({ isOpen, toggleMenu }: IProps): JSX.Element | null => {
  const { mdOrDown } = useRenderOn();

  const closeMenu = (): void => {
    toggleMenu({ isOpen: false });
  };

  return mdOrDown ? (
    <Sidebar isOpen={isOpen} toggle={toggleMenu} width={"85%"}>
      <AppContentMenu closeMenu={closeMenu} />
    </Sidebar>
  ) : null;
};

export default AppMenu;
